import formatters from '@/utils/formatter';

export default {
    methods: {
        ...formatters,
    },
};



// WEBPACK FOOTER //
// ./src/mixins/formatters.js